import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSessionStatus } from "../../../store/root.selectors";
import { Notificator } from "../store";

export const useSessionExpirationNotification = () => {
  const dispatch = useDispatch();
  const isSessionExp = useSelector(getSessionStatus);

  useEffect(() => {
    if (isSessionExp) {
      dispatch(Notificator.sessionExpiration());
    }
  }, [dispatch, isSessionExp]);
};
